// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PaperClipOutlinedSvg from "@fishx/icons-svg/es/asn/PaperClipOutlined";
import FishxIcon from '../components/FishxIcon';

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PaperClipOutlinedSvg
  }));
};

PaperClipOutlined.displayName = 'PaperClipOutlined';
export default React.forwardRef(PaperClipOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PaperClipOutlined.js
// module id = 3752
// module chunks = 0